import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


export const mytodo = (params) => {
  return axios.post(root + '/wf/todolist/mytodo', qs.stringify(params))
}
export const update = (params) => {
  return axios.post(root + '/wf/todolist/update', qs.stringify(params))
}
export const updatehis = (params) => {
  return axios.post(root + '/wf/todolist/updatehis', qs.stringify(params))
}

export const testapply = (params,flag) => {
  if (flag) {
    return axios.post(root + '/wf/todolist/testapply', qs.stringify(params))
  } else {
    return axios.post(root + '/wf/todolist/testEditForm', qs.stringify(params))
  }
}

export const testdetail = (params) => {
    return axios.post(root + '/wf/todolist/testdetail', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/wf/todolist.js